export default "__VITE_ASSET__cbb10ff4__"